import ArrowBackIosNew from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { SxProps, Theme } from '@mui/material/styles';
import { FC, useCallback, useEffect, useRef } from 'react';

import CardDeck from './CardDeck';
import { CardBox, OuterBox, StyledButtonLeft, StyledButtonRight } from './styled';
import { CardDeckProps, ScrollDirection } from './type';

const SX_BUTTON: SxProps<Theme> = { display: { sm: 'flex', xs: 'none' } };

const ResponsiveCardDeck: FC<CardDeckProps> = ({ cards, onCardClick, sx }) => {
  const timeoutRef = useRef<number>(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleCardClick = useCallback((id: string) => onCardClick?.(id), [onCardClick]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearInterval(timeoutRef.current);
    };
  }, []);

  const stopScroll = useCallback(() => {
    if (timeoutRef.current) {
      clearInterval(timeoutRef.current);
      timeoutRef.current = 0;
    }
  }, []);

  const startScroll = useCallback(
    (direction: ScrollDirection) => {
      stopScroll();

      const velocity = direction === ScrollDirection.Right ? 10 : -10;
      timeoutRef.current = setInterval(() => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.scrollLeft += velocity;
        }
      }, 8) as unknown as number; // ~120fps
    },
    [stopScroll]
  );

  return (
    <OuterBox sx={{ ...sx, padding: { sm: '0 24px', xs: '0' } }}>
      <StyledButtonLeft
        onMouseDown={() => startScroll(ScrollDirection.Left)}
        onMouseLeave={stopScroll}
        onMouseUp={stopScroll}
        sx={SX_BUTTON}
      >
        <ArrowBackIosNew />
      </StyledButtonLeft>

      <CardBox ref={scrollContainerRef}>
        <CardDeck cards={cards} onCardClick={handleCardClick} />
      </CardBox>

      <StyledButtonRight
        onMouseDown={() => startScroll(ScrollDirection.Right)}
        onMouseLeave={stopScroll}
        onMouseUp={stopScroll}
        sx={SX_BUTTON}
      >
        <ArrowForwardIos />
      </StyledButtonRight>
    </OuterBox>
  );
};

export default ResponsiveCardDeck;
